// export const API = "https://d2c-backend-1.onrender.com";
// export const API = "https://d2c-backend.onrender.com"; //for master branch onrender testnet
export const API = "https://13.203.87.32.nip.io"; // main
// export const API = "http://3.109.246.108"; // master
// export const API = "http://localhost:8080";

export const contractAddress = "0x5f8bD1e7b8819a433262a3e2fB16a5481fd01739"; // Temperary Contract Address
// export const contractAddress = "0x620c1CcE9C7F8b23262DF5901Af84a729F6C3458"; // Personal Temperary Contract Address 15/01/2025
export const airDrop_contract_address =
  "0xb4DC6d0b9Cfd5E8453f4a942DafF3d9f8D86eDe9";
// export const auction_contract_address =
//   "0xF2404E55322A4F7B025BBA3d45a3D40aCEE6cFdc";
export const auction_contract_address =
  "0x7dD3B44f45b3E04BD71A02956f13F4cbDc73fC30";  // for main

export const fractional_nft_contract_address =
  "0x5Db7Ad83CAF99A462C00A2966755D1861b112f91";

export const projectId = "0xb6aCc0C1c2b1213ba6e632e9f180104275D9f516";

export const SIGNING_DOMAIN_NAME = "DTC";
export const SIGNING_DOMAIN_VERSION = "1";
export const chainId = 11155111;
